module.exports = __webpack_public_path__ + "static/img/liBgImage4-hover.34e6fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productCenter/subnav1/tab1/liBgImage4-hover.png
// module id = iT6V
// module chunks = 0